import React, { useState } from 'react';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('home');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'home':
        return <Home />;
      case 'leagues':
        return <Leagues />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <h1 className="app-title">🏈 Reality Fantasy Football</h1>
          <p className="app-subtitle">Your Ultimate Fantasy Football Experience</p>
        </div>
      </header>
      
      <nav className="tab-navigation">
        <button 
          className={`tab-button ${activeTab === 'home' ? 'active' : ''}`}
          onClick={() => setActiveTab('home')}
        >
          🏠 Home
        </button>
        <button 
          className={`tab-button ${activeTab === 'leagues' ? 'active' : ''}`}
          onClick={() => setActiveTab('leagues')}
        >
          🏆 Leagues
        </button>
      </nav>

      <main className="main-content">
        {renderTabContent()}
      </main>
    </div>
  );
}

// Home Component
const Home = () => {
  return (
    <div className="home-container">
      <div className="welcome-section">
        <h2>Welcome to Reality Fantasy Football!</h2>
        <p>Your one-stop destination for managing your fantasy football leagues and tracking player performance.</p>
        
        <div className="stats-overview">
          <div className="stat-item">
            <span className="stat-number">3</span>
            <span className="stat-label">Active Leagues</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">36</span>
            <span className="stat-label">Teams</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">18</span>
            <span className="stat-label">This Week's Matchups</span>
          </div>
        </div>
      </div>

      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">📊</div>
          <h3>Player Stats</h3>
          <p>Track real-time player statistics and performance metrics.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">🏆</div>
          <h3>League Management</h3>
          <p>Manage multiple fantasy football leagues and keep track of standings and matchups.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">📈</div>
          <h3>Analytics</h3>
          <p>Get insights and analytics to help you make better fantasy football decisions.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">⚡</div>
          <h3>Real-time Updates</h3>
          <p>Stay updated with live scores and real-time player performance data.</p>
        </div>
      </div>

      <div className="data-sections">
        <div className="standings-section">
          <h3>🏆 League Standings</h3>
          <div className="standings-table">
            <div className="standings-header">
              <span>Team</span>
              <span>W-L</span>
              <span>PF</span>
              <span>PA</span>
            </div>
            <div className="standings-row">
              <span className="team-name">Team Alpha</span>
              <span className="record">4-1</span>
              <span className="points">1250</span>
              <span className="points">1100</span>
            </div>
            <div className="standings-row">
              <span className="team-name">Team Beta</span>
              <span className="record">4-1</span>
              <span className="points">1200</span>
              <span className="points">1150</span>
            </div>
            <div className="standings-row">
              <span className="team-name">Team Gamma</span>
              <span className="record">3-2</span>
              <span className="points">1180</span>
              <span className="points">1200</span>
            </div>
          </div>
        </div>

        <div className="matchups-section">
          <h3>⚡ This Week's Matchups</h3>
          <div className="matchups-list">
            <div className="matchup-card">
              <div className="matchup-teams">
                <div className="team">
                  <span className="team-name">Team Alpha</span>
                  <span className="team-score">125</span>
                </div>
                <div className="vs">vs</div>
                <div className="team">
                  <span className="team-name">Team Beta</span>
                  <span className="team-score">118</span>
                </div>
              </div>
              <div className="matchup-status">Final</div>
            </div>
            <div className="matchup-card">
              <div className="matchup-teams">
                <div className="team">
                  <span className="team-name">Team Gamma</span>
                  <span className="team-score">0</span>
                </div>
                <div className="vs">vs</div>
                <div className="team">
                  <span className="team-name">Team Delta</span>
                  <span className="team-score">0</span>
                </div>
              </div>
              <div className="matchup-status">Scheduled</div>
            </div>
          </div>
        </div>

        <div className="top-performers-section">
          <h3>⭐ Top Performers</h3>
          <div className="performers-list">
            <div className="performer-card">
              <div className="performer-info">
                <span className="performer-name">Josh Allen</span>
                <span className="performer-details">QB • BUF</span>
              </div>
              <div className="performer-points">28.5</div>
            </div>
            <div className="performer-card">
              <div className="performer-info">
                <span className="performer-name">Christian McCaffrey</span>
                <span className="performer-details">RB • SF</span>
              </div>
              <div className="performer-points">32.1</div>
            </div>
            <div className="performer-card">
              <div className="performer-info">
                <span className="performer-name">Tyreek Hill</span>
                <span className="performer-details">WR • MIA</span>
              </div>
              <div className="performer-points">24.8</div>
            </div>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h3>Quick Actions</h3>
        <div className="action-buttons">
          <button className="action-button primary">
            View My Leagues
          </button>
          <button className="action-button secondary">
            Check Player Stats
          </button>
          <button className="action-button secondary">
            View Standings
          </button>
        </div>
      </div>
    </div>
  );
};

// Leagues Component
const Leagues = () => {
  const [showCreateLeague, setShowCreateLeague] = useState(false);

  return (
    <div className="leagues-container">
      <div className="leagues-header">
        <h2>My Fantasy Leagues</h2>
        <button 
          className="create-league-btn"
          onClick={() => setShowCreateLeague(!showCreateLeague)}
        >
          + Create New League
        </button>
      </div>

      {showCreateLeague && (
        <div className="create-league-form">
          <h3>Create New League</h3>
          <form>
            <div className="form-group">
              <label>League Name:</label>
              <input type="text" placeholder="Enter league name" />
            </div>
            <div className="form-group">
              <label>Number of Teams:</label>
              <select>
                <option value="8">8 Teams</option>
                <option value="10">10 Teams</option>
                <option value="12">12 Teams</option>
                <option value="14">14 Teams</option>
              </select>
            </div>
            <div className="form-group">
              <label>Season:</label>
              <input type="text" value="2024" readOnly />
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-btn">Create League</button>
              <button 
                type="button" 
                className="cancel-btn"
                onClick={() => setShowCreateLeague(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="leagues-grid">
        <div className="league-card">
          <div className="league-header">
            <h3>Reality Fantasy League</h3>
            <span className="status-badge active">Active</span>
          </div>
          <div className="league-info">
            <div className="info-item">
              <span className="label">Season:</span>
              <span className="value">2024</span>
            </div>
            <div className="info-item">
              <span className="label">Teams:</span>
              <span className="value">12</span>
            </div>
            <div className="info-item">
              <span className="label">Current Week:</span>
              <span className="value">5</span>
            </div>
          </div>
          <div className="league-actions">
            <button className="league-btn primary">View League</button>
            <button className="league-btn secondary">Settings</button>
          </div>
        </div>

        <div className="league-card">
          <div className="league-header">
            <h3>Champions League</h3>
            <span className="status-badge active">Active</span>
          </div>
          <div className="league-info">
            <div className="info-item">
              <span className="label">Season:</span>
              <span className="value">2024</span>
            </div>
            <div className="info-item">
              <span className="label">Teams:</span>
              <span className="value">10</span>
            </div>
            <div className="info-item">
              <span className="label">Current Week:</span>
              <span className="value">5</span>
            </div>
          </div>
          <div className="league-actions">
            <button className="league-btn primary">View League</button>
            <button className="league-btn secondary">Settings</button>
          </div>
        </div>

        <div className="league-card">
          <div className="league-header">
            <h3>Legends Division</h3>
            <span className="status-badge draft">Draft</span>
          </div>
          <div className="league-info">
            <div className="info-item">
              <span className="label">Season:</span>
              <span className="value">2024</span>
            </div>
            <div className="info-item">
              <span className="label">Teams:</span>
              <span className="value">8</span>
            </div>
            <div className="info-item">
              <span className="label">Current Week:</span>
              <span className="value">0</span>
            </div>
          </div>
          <div className="league-actions">
            <button className="league-btn primary">View League</button>
            <button className="league-btn secondary">Settings</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
